import React, { useState } from 'react';
import ListLotFields from './ListLotFields.js';
import AddLotField from './AddLotField.js';
import { ListButton, AddButton, FAB } from '../../shared/ActionButtons';

export const LotFields = ({ screen, setScreen, hideHeader }) => {
  const [localScreen, setLocalScreen] = useState('list');

  const currentScreen    = screen    !== undefined ? screen    : localScreen;
  const setCurrentScreen = setScreen !== undefined ? setScreen : setLocalScreen;

  return (
    <>
      {!hideHeader && (
        <div className="content-header">
          <div className="action-buttons">
            <ListButton isActive={currentScreen === 'list'} onClick={() => setCurrentScreen('list')} />
            <AddButton  isActive={currentScreen === 'add'}  onClick={() => setCurrentScreen('add')} />
          </div>
        </div>
      )}
      {currentScreen === 'list' && <ListLotFields />}
      {currentScreen === 'list' && <FAB onClick={() => setCurrentScreen('add')} />}
      {currentScreen === 'add'  && <AddLotField onSuccess={() => setCurrentScreen('list')} />}
    </>
  );
};

export const LotFieldsActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton isActive={screen === 'list'} onClick={() => setScreen('list')} />
    <AddButton  isActive={screen === 'add'}  onClick={() => setScreen('add')} />
  </div>
);

export default LotFields;
